import {Component, Inject, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {LocalizableError} from 'src/app/models/LocalizableError';
import {LabelsService} from 'src/app/services/labels.service';
import {environment} from '../../../environments/environment';
import {ImageHelper} from '../../helpers/ImageHelper';
import {Event} from '../../models/Event';
import {EVENT_SERVICE, LABELS_SERVICE} from '../../providers/service.providers';
import {EventService} from '../../services/event.service';
import {ScrollService} from '../../services/scroll.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    public allEvents: Event[];
    public filteredEvents: Event[];
    public isLoading: boolean;
    public isTypeFiltered: boolean;
    public error?: LocalizableError;
    private subject: Subject<string> = new Subject();
    private defaultImageUrlSelfHosted = 'default-event-image.jpg';
    private defaultImageUrlCrmHosted = 'homehero.jpg';

  constructor(
    private scrollService: ScrollService,
    @Inject(EVENT_SERVICE) private eventService: EventService,
    @Inject(LABELS_SERVICE) public labelsService: LabelsService,
    private imageHelper: ImageHelper) {}

    ngOnInit(): void {
        this.loadPublishedEvents();
        this.subject.pipe(
            debounceTime(300)
        ).subscribe((searchTextValue) => {
            this.handleSearch(searchTextValue);
        });
    }

    private loadPublishedEvents() {
        this.isLoading = true;
        this.isTypeFiltered = false;
        this.eventService.getPublishedEvents().subscribe(
            (events) => {
              events = events.filter((event) => {
                const today = new Date();
                return (new Date(event.endDate) >= today);
              });
              events = events.sort(function(a, b) {
                return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
              });
              if (environment.eventtypeid && environment.eventtypeid !== 'all') {
                    events = events.filter((event) => {
                        return (event.customFields &&
                            event.customFields.ti8m_eventtypeid &&
                            event.customFields.ti8m_eventtypeid.Id &&
                            event.customFields.ti8m_eventtypeid.Id === environment.eventtypeid);
                    });
                    this.isTypeFiltered = true;
                }
              this.allEvents = events;
              this.filteredEvents = events;
              this.isLoading = false;
              this.scrollService.handleScrollAfterLoad();
            },
            (error: LocalizableError) => this.handleErrorResponse(error)
        );
    }

    private handleErrorResponse(error: LocalizableError) {
        this.error = error;
        this.isLoading = false;
    }

    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }

    getAreaLabel(event: Event): string {
        const date = this.labelsService.getDateString(event);
        const building = event.building ? `at ${event.building?.name}` : '';
        return `${event.eventName} on ${date} ${building}`;
    }

    handleSearch(searchText: string) {
        if (searchText) {
            searchText = searchText.toLocaleLowerCase();
        }
        this.filteredEvents = this.allEvents.filter((it: Event) => {
            return it.eventName.toString().toLocaleLowerCase().includes(searchText);
        });
    }

    search(searchText: string) {
        this.subject.next(searchText);
    }

    orderEvents(order: string) {
        if (order === 'date-asc') {
            this.filteredEvents.sort((a, b) => (Number(new Date(a.startDate.toString()))) - (Number(new Date(b.startDate.toString()))));
        } else if (order === 'date-desc') {
            this.filteredEvents.sort((a, b) => (Number(new Date(b.startDate.toString()))) - (Number(new Date(a.startDate.toString()))));
        } else if (order === 'name-asc') {
            this.filteredEvents.sort((a, b) => a.eventName.localeCompare(b.eventName));
        } else if (order === 'name-desc') {
            this.filteredEvents.sort((a, b) => b.eventName.localeCompare(a.eventName));
        }
    }

    public getBannerImage(event) {

        if (event.image != null) {
            return event.image;
        } else {
            if (environment.useRestStack === true) {
                return this.imageHelper.getImageUrl(this.defaultImageUrlSelfHosted);
            } else {
                return this.imageHelper.getImageUrl(this.defaultImageUrlCrmHosted);
            }
        }
    }

    public hasExternalLink(event) {
      return event.publicEventUrl && !event.publicEventUrl.includes('.microsoftcrmportals.com');
    }
}
